module.exports = __webpack_public_path__ + "static/signature-6b2a2d49704a160e198b90ed06a62de0.svg";